// extracted by mini-css-extract-plugin
export default {"card":"style_card__me5k6","card--rounded":"style_card--rounded__9NE3O","card--bordered":"style_card--bordered__C90Oh","card--shadow":"style_card--shadow__MnbOB"};